module.exports = __webpack_public_path__ + "img/icon-person-w.5b0c13e1.svg";